"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ShapeGLPipeline = exports.ShapeGLPipelineModes = void 0;

var _glCore = require("@capture/gl-core");

var _ShapeGrayScaleGLFilter = _interopRequireDefault(require("./filters/ShapeGrayScaleGLFilter"));

var _ShapeStructureTensorGLFilter = _interopRequireDefault(require("./filters/ShapeStructureTensorGLFilter"));

var _ShapeGaussianBlurGLFilter = _interopRequireDefault(require("./filters/ShapeGaussianBlurGLFilter"));

var _ShapeTensorMagnitudeGLFilter = _interopRequireDefault(require("./filters/ShapeTensorMagnitudeGLFilter"));

var _ShapeDogPass1GLFilter = _interopRequireDefault(require("./filters/ShapeDogPass1GLFilter"));

var _ShapeDogSmoothGLFilter = _interopRequireDefault(require("./filters/ShapeDogSmoothGLFilter"));

var _ShapeBlurCutoffGLFilter = _interopRequireDefault(require("./filters/ShapeBlurCutoffGLFilter"));

var _ShapeDrawPointsFilter = _interopRequireDefault(require("./filters/ShapeDrawPointsFilter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ShapeGLPipelineModes = {
  DEFAULT: 0,
  DRAW: 1,
  ERASE: 2
};
exports.ShapeGLPipelineModes = ShapeGLPipelineModes;

class ShapeGLPipeline extends _glCore.GLFilterPipeline {
  constructor() {
    const grayScaleFilter = new _ShapeGrayScaleGLFilter.default();
    const dogPass1Filter = new _ShapeDogPass1GLFilter.default();
    const dogSmoothFilter = new _ShapeDogSmoothGLFilter.default();
    const blurCuttoffFilter = new _ShapeBlurCutoffGLFilter.default();
    const drawFilter = new _ShapeDrawPointsFilter.default();
    super([grayScaleFilter, new _ShapeStructureTensorGLFilter.default(), new _ShapeGaussianBlurGLFilter.default(0.0), new _ShapeGaussianBlurGLFilter.default(1.0), new _ShapeTensorMagnitudeGLFilter.default(), dogPass1Filter, dogSmoothFilter, new _glCore.GLVerticalFilterNode([blurCuttoffFilter, drawFilter])]);
    this._mode = ShapeGLPipelineModes.DEFAULT;
    this.grayScaleFilter = grayScaleFilter;
    this.dogPass1Filter = dogPass1Filter;
    this.dogSmoothFilter = dogSmoothFilter;
    this.blurCuttoffFilter = blurCuttoffFilter;
    this.drawFilter = drawFilter;

    this._setTextures();
  }

  setSize(gl, width, height) {
    super.setSize(gl, width, height);

    this._setTextures();
  }

  setDetail(valueInPercentage) {
    this.blurCuttoffFilter.setDetail(valueInPercentage);
  }

  getDetail() {
    return this.blurCuttoffFilter.getDetail();
  }

  _setTextures() {
    this.dogPass1Filter.setTexture2(this.frameBufferTextures[0]);
    this.dogSmoothFilter.setTexture2(this.frameBufferTextures[4]);
  }

  isInverted() {
    return this.grayScaleFilter.isInverted();
  }

  setInverted(state) {
    this.grayScaleFilter.setInverted(state);
  }

  setMode(mode) {
    this._mode = mode;
  }

  getMode() {
    return this._mode;
  }

  setPath(points) {
    this.drawFilter.points = points;
  }

  toggleDrawMode() {
    this._mode = this._mode !== ShapeGLPipelineModes.DRAW ? ShapeGLPipelineModes.DRAW : ShapeGLPipelineModes.DEFAULT;

    if (this._mode === ShapeGLPipelineModes.DRAW) {
      this.drawFilter.isDrawMode = true;
    }
  }

  toggleEraseMode() {
    this._mode = this._mode !== ShapeGLPipelineModes.ERASE ? ShapeGLPipelineModes.ERASE : ShapeGLPipelineModes.DEFAULT;

    if (this._mode === ShapeGLPipelineModes.ERASE) {
      this.drawFilter.isDrawMode = false;
    }
  }

  processTouch(location, isNewPath = false) {
    if (this._mode === ShapeGLPipelineModes.DRAW || this._mode === ShapeGLPipelineModes.ERASE) {
      this.drawFilter.add(location, isNewPath);
    }
  }

}

exports.ShapeGLPipeline = ShapeGLPipeline;

var _default = new ShapeGLPipeline();

exports.default = _default;